var map = {
	"./automata_campaign.postman_collection.json": 7973,
	"./automata_core.postman_collection.json": 6386,
	"./automata_environment.postman_collection.json": 7676,
	"./automata_performance.postman_collection.json": 2897,
	"./automata_tasks.postman_collection.json": 4569,
	"./kgtech_security.postman_collection.json": 1729
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6034;